// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Button, LinkButton } from '@storylinerlabs/design';
import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote';

// import types
import { FixMeLater } from '../../types';

// import components
import ClickToTweet from './ClickToTweet';
import HtmlInMdx from './HtmlInMdx';
import LinkComponent from './LinkComponent';
import MarkdownImage from './MarkdownImage';
import MarkdownLink from './MarkdownLink';
import PromoBox from './PromoBox';

// import styles
import styles from './Markdown.module.css';

// define component
const RemoteMarkdown: React.FunctionComponent<{ content: MDXRemoteSerializeResult }> = ({
  content,
}) => (
  <div className={styles['markdown']}>
    <MDXRemote
      components={
        {
          Button,
          ClickToTweet,
          HtmlInMdx,
          LinkButton,
          LinkComponent,
          PromoBox,
          StorylinerImage: MarkdownImage,
          a: MarkdownLink,
        } as FixMeLater
      }
      {...content}
    />
  </div>
);

RemoteMarkdown.propTypes = {
  content: PropTypes.shape({ compiledSource: PropTypes.string.isRequired }).isRequired,
};

export default RemoteMarkdown;
